import {orderBy} from "../../lib/Utils";
import {merge, pick, indexOf, includes, isString, cloneDeep} from "lodash";
import {convertDatesDeep, revertDatesDeep} from "../aodUtils";


// Item is crap name - it means keyed chunk of data we are pulling/pushing from/to the server
// Either a DB record or record set (usually with sub records in a graph)

//todo sort caps for objects vs loawer case for items Project vs project

export default function AodItem(name,  aodService, options)
{
    this.name = name;
    this.plural = name +'s';
    //this.hasAssets = false;
    this.aodService = aodService;
    this.searchPaths = [];   // allowed urls search paths
    merge(this, options);
}

AodItem.prototype =
{
    // Response pre-processing
    //  - timestamps -> javascript dates
    //  - resolve item lists to an ordered Array using the plural name

    expandResponse: function expandResponse(res) {
        this.marshallItems(res);
        convertDatesDeep(res);
        return res;
    },

    // Note this used to process records - now just grads already stored list
    getRecords: function getRecords(data) {
        return data[this.plural];
    },

    marshallItems: function(data){
        var records = [];
        if (data[this.name]) { //Single record}
            records = [data[this.name]];
        } else if (data[this.plural]) {   // named set  // Note now always converts from object to array
            records = orderBy(data[this.plural], this.name + 'Order' in data ? data[this.name + 'Order'] : null);
        }
        records.forEach(rec=>this.expandRecord(rec));

        data[this.plural] = records;
        return data;
    },

    expandRecord: function(rec){
        if (this.hasAssets) {
            this.addAssetUrls(rec);
        }

        if ('subItems' in this) {
            this.subItems.forEach(subType => {

                //const subItemCall = this.aodService.itemCalls[subType];
                //const {plural} = subItemCall;
                //rec[plural] = subItemCall.getRecords(rec);

                this.aodService.itemCalls[subType].marshallItems(rec);
            })
        }

        // todo ? process single subRec
        return rec;
    },

    getRecord: function(data){
        return  this.getRecords(data)[0];
    },

    getUrl: function(path, id, params)
    {
        return this.aodService.getUrl() +'/'+ this.getQueryPath(path, id, params);
    },

    //Depricated?
    getQueryPath: function getQueryPath(path, id, params)
    {
        let urlParams ='';

        if ( params) {
             const vettedParams = this.vetParams(params);
             urlParams = new URLSearchParams(vettedParams).toString();
        }

        return this.name + '/' + (path ? path+'/' : '') + (id ? id : '') + '?' + urlParams;
    },

    vetParams: function vetParams(params={})
    {
        //TBD these are really call/item  specific
        const vettedParams =  pick(params,'view',
            'userName','password','pretty',
            'sortColumn','ascending',
            'firstRow','pageSize',
            'personType','firstName','lastName','email',
            'userPrivilege','roleTargetType','roleTargetId',
            'exactMatch',
            'force','async','sync',
            'fileAspect','version','useSoloSpecAd',
            'ownerType','ownerId','fileClass','fileType',
            'fieldName','fieldValue','comparisonType',
            'copyItems', 'copyShares', 'copyTrash', 'sendShareNotifications',
            'type',  // NOTE conflicts with ajax options
            'fileName', 'contentType', 'url', 'recordVersion'
        );

        if ('sortBy' in params) {
            vettedParams.sortColumn = params.sortBy;
        }
        if ('sortReverse' in params) {
            vettedParams.ascending = ! params.sortReverse;  //TBD ?convert to string
        }

        return vettedParams;
    },

    submitCommand: function submitCommand({path, id, params, ...options}){
        options.queryPath = this.name + '/' + (path ? path+'/' : '') + (id ? id : '');
        options.params = this.vetParams(params);

        if ('method' in options
            && ( options.method.match(/^P(U|OS)T$/i))
            && ! ((path||'').match(/^(uploadAndAttach)$/i))
        ) {
            options.params.data = cloneDeep(options.params.data);  // so non destructive
            revertDatesDeep(options.params.data);
        }

        var self = this;
        return this.aodService.submitRequest(options)
            .then(function(response){
                return self.expandResponse(response);
            });
    },

    // we always ask for one extra - if we don't get it we know we're done
    // deprecated
    checkMore: function checkMore(response,pageSize)
    {
        response.more = false;
        if (pageSize > 0)
        {
            var order = response[this.name+'Order'];
            response.more = order.length === pageSize;
            if (response.more) {
                delete response[this.plural][order.pop()];  // drop the extra one
            }
        }
        return response;
    },

    load: function(id, options)
    {
        // todo this is kinda wierd
        return this.submitCommand(
            merge(options, {
                id: id,
                params:merge({},options,{view:'full'})
            })
        );
    },

    create: function(record){
        return this.submitCommand({
            params: {view:'full'},
            method: 'POST',
            data: record
        })
    },

    // Supported for Projects
    // options (boolean): copyItems, copyShares, copyTrash, sendShareNotifications
    copy: function(id,record,options)
    {
        this.submitCommand({
            path: 'copy',
            id,
            params: merge({view:'full'},options),
            method: 'PUT',
            data: record
        });
    },

    // Supported for Projects
    // options (boolean): copyItems, copyShares, copyTrash, sendShareNotifications
    // original "archived",  clone inherits "key" and becomes head
    clone: function(id,record,options)
    {
        this.submitCommand({
            path: 'clone',
            id,
            params: merge({view:'full'},options),
            method: 'PUT',
            data: record
        });
    },
    Xclone: function(id,record,options)
    {
        options = merge({view:'full'},options);
        return this.aodService.submitRequest({
            queryPath: this.getQueryPath('clone',id,options),
            method: 'PUT',
            data: record
        });
    },

    // Supported for Projects
    // gets project of type lightbox creating if doesn't exists
    // should only be one per user
    Xlightbox: function(options)
    {
        var request = merge(options, {
            queryPath: this.getQueryPath('lightbox','',merge(options,{view:'full'}))
        });
        return this.aodService.submitRequest( request );
    },
    lightbox: function(options)
    {
        return this.submitCommand(
            merge(options, {
                path: 'lightbox',
                params:merge({},options,{view:'full'})
            })
        );
    },

    Xupdate: function(id,record)
    {
        return this.aodService.submitRequest({
            queryPath: this.getQueryPath('',id,{view:'full'}),
            method: 'PUT',
            data: record
        });
    },
    update: function(id,record)
    {
        return this.submitCommand({
            id,
            params: {view:'full'},
            method: 'PUT',
            data: record
        });
    },

    Xremove: function(id, options)
    {
        var request = merge(options, {
            queryPath: this.getQueryPath('',id),
            method: 'DELETE'
        });
        return this.aodService.submitRequest(request);
    },
    remove: function(id, options)
    {
        return this.submitCommand(
            merge(options, {
                id,
                method: 'DELETE'
            })
        );
    },

    all: function(options)
    {
        const request = merge({
            //pageSize:-1,
            path: options.call,
            params: options
        },options);
        //if (options.pageSize > 0) {
        //    options.pageSize++;  // todo !! don't change passed in data
        //}

        const self = this;
        return this.submitCommand(request);
        //    .then( function(response) {
        //        return self.checkMore(response,request.pageSize);
        //    });
    },


    // custom calls
    Xrestore: function(id,options)
    {
        var request = merge(options, {
            queryPath: this.getQueryPath('restore',id,{view:'full'})
        });
        return this.aodService.submitRequest(request);
    },
    restore: function(id,options)
    {
        return this.submitCommand( merge(options, {
            path:'restore',
            id,
            params: {view:'full'}
        }));
    },
    // ?needs more than just adding back in


    search: function(parentId,key, options)
    {
        const subPath = (key && (indexOf(this.searchPaths,key)>=0)) ? '/' + key : '';

        const request = merge({
            //pageSize:-1,
            path: 'search' + subPath,
            id: parentId,
            params: options
        },options);
        //if (options.pageSize > 0) {
        //    options.pageSize++;
        //}

        //const self = this;
        return this.submitCommand(request);
        //    .then( function(response) {
        //        return self.checkMore(response,request.pageSize);
        //    });
    },


    // Access by inherited reference
    // takes: version [default = last], view
    // suported for projects
    Xfind: function(key, options)
    {
        var request = merge(options, {
            queryPath: this.getQueryPath('find', key,  options)
        });
        return this.aodService.submitRequest(request);
    },
    find: function(key, options)
    {
        return this.submitCommand( merge(options, {
            path: 'find',
            id: key,
            params: options
        }));
    },

    Xtrash: function(parentId,options)
    {
        var request = merge(options, {
            queryPath: this.getQueryPath('trash',parentId)
        });
        return this.aodService.submitRequest(request);
    },
    trash: function(parentId,options)
    {
        return this.submitCommand( merge(options, {
            path:'trash',
            id: parentId
        }));
    },
    // Should trashed records just go in the list or seomwhere else

    Xrender: function(id,options)
    {
        var request = merge(options, {
            queryPath: this.getQueryPath('render',id, merge(options,{'async':'true'}))
        });

        return this.aodService.submitRequest(request);
        /*       .fail( function(data)
               {
                   renderManager.abort();  ///NOTE only applies to SS but we don't render individual ads from the client
               });*/
    },
    render: function(id,options)
    {
        return this.submitCommand( merge(options, {
            path:'render',
            id,
            params: merge(options,{'async':'true'})
        }));
    },//spec ad & salesSheet only


    getAssetUrl: function(id,aspect,version, options)  //specad, sales sheet & managedFiles only
    {
        //todo - this is item specific
        var validAspects=['THUMBNAIL','PREVIEW','ORIGINAL'];
        aspect = isString(aspect) ? aspect.toUpperCase() : '';

        var params = { fileAspect: (includes(validAspects,aspect) ? aspect : 'PREVIEW' ) };
        if (version > 0) {
            params.version = version;
        }
        merge(params,options);

        return this.getUrl('asset', id, params) ;
    },

    addAssetUrls: function (record){
        const {id, recordVersion} = record;
        // recordVersion ought to ensure we aren't used cached images - server may need to set MODIFIED/etag
        return merge(record, {
            thumbUrl: this.getAssetUrl(id, 'THUMBNAIL', 0, {recordVersion}),
            previewUrl: this.getAssetUrl(id, 'PREVIEW', 0,{recordVersion}),
            originalUrl: this.getAssetUrl(id, 'ORIGINAL', 0, {recordVersion})
        });
    },

    getRemoteAssetUrl: function(id,aspect,version, options)  //specad, sales sheet & managedFiles only
    {
        console.log('Depricated: getRemoteAssetUrl');
        return this.getAssetUrl(id,aspect,version, options) ;
    },


    // Untested/used
    Xasset: function(id,aspect,version, options)
    {
        //aspect ORIGINAL, PREVIEW, THUMBNAIL
        var request = merge(options, {
            queryPath: this.getQueryPath('asset',id),
            responseType: '?data'  // not data
        });
        return this.aodService.submitRequest(request);
    },
    asset: function(id,aspect,version, options)
    {
        //aspect ORIGINAL, PREVIEW, THUMBNAIL
        return this.submitCommand( merge(options, {
            path:'asset',
            id,
            responseType: '?data'  // not data
        }));
    },

    /*   parseUrl: function parseUrl(url)
       {
           var bits = url.match( /\/(\w+)\/asset\/(\d+)\?fileAspect\=(\w+))\&version\=(\d+)/ );
           return {item:bits[1], id:bits[2], aspect:bits[3], version:bits[4]};
       },
    */
    // Material only - should attach to just managedFile
    XattachArtwork: function(name,ownerId,ownerType)   // ?Flexible source
    {
        return this.aodService.submitRequest({
            queryPath: this.getQueryPath('attachArtwork/MS',name, {ownerId:ownerId, ownerType:ownerType}),
            method: 'PUT',
            data: {},  // could set fileName && contentType?
        });
    },

    //TODO - untested
    attachArtwork: function(name,ownerId,ownerType)   // ?Flexible source
    {
        return this.submitCommand({
            path:'attachArtwork/MS',
            id: name,
            params: {ownerId:ownerId, ownerType:ownerType},
            method: 'PUT',
            data: {},  // could set fileName && contentType?
        });
    },

    /* ios?
    // Material only - should attach to just managedFile
    uploadAndAttach: function(photoURI,ownerId,ownerType,fileName)   // ?Flexible source
    {
        // TBD?? Not working - params are just being added to the URL in the aodItem call
        var params = {ownerId:ownerId, ownerType:ownerType} ;
        var queryPath= this.getQueryPath('uploadAndAttach',null,params);

        return this.aodService.uploadURI(photoURI, queryPath, params, fileName);
    },
    */

    //options ... fileClass, fileType, contentType ?fileName
    uploadAndAttach: function(file,ownerId,ownerType, options={})   // managedFile only
    {
        const params = {ownerId, ownerType, fileName: file.name, contentType: file.type,  ...options} ;
        const data = new FormData();
        data.append('file', file);
        data.append('fileName', file.name);

        return this.submitCommand({
            path: 'uploadAndAttach',
            params ,
            method: 'POST',
            data,
        });
    },

    retrieveAndAttach: function(file,ownerId,ownerType, options={})   // managedFile only
    {
        const params = {
            ownerId, ownerType,
            fileName: file.name, contentType: file.type,
            url: file.url,
            ...options
        };
        const data = new FormData(); // call barfing - maybe it expects some data

        return this.submitCommand({
            path: 'retrieveAndAttach',
            params ,
            method: 'POST',
            data
        });
    },


    // person only
    Xrole:function(role, targetType, targetId,key, options)
    {
        var params = {userPrivilege: role, roleTargetId:targetId, roleTargetType:targetType} ;

        var request = merge(options, {
            queryPath: this.getQueryPath('peopleWithRole',null, params)
        });

        return this.aodService.submitRequest(request);
    },
    role:function(role, targetType, targetId,key, options)
    {
        return this.submitCommand( merge(options, {
            path: 'peopleWithRole',
            params: {
                userPrivilege: role,
                roleTargetId: targetId,
                roleTargetType: targetType
            }
        }));
    },

    // project only
    global: function(options)
    {
        options = options || {};
        options.call = 'global';

        return this.all(options);
    },


    // Order functions
    home: function(){},
    homeTab: function(){},

    Xcommand: function(command,record,options)
    {
        options = merge({view:'full'},options);
        return this.aodService.submitRequest({
            queryPath: this.getQueryPath(command,'',options),
            method: 'PUT',
            data: record
        });
    },
    command: function(command,record,options)
    {
        return this.submitCommand({
            path: command,
            params: merge({view:'full'},options),
            method: 'PUT',
            data: record
        });
    },

    //TBD validate allowed commands
    _orderCommands: ['createAndSubmit','submit','resubmit','release','releaseWithChanges'],


    // Accounts only

    hierarchy: function(id,options){

        const defaultParams = {
            status:'ACTIVE',
            view:'minimal',
            includeAccount: true
        };

        this.submitCommand({
            path: 'hierarchy',
            id,
            params: merge(defaultParams,options)
        });
    },

    // Spec Ad only
    // todo ?why are these GET

    lock: function(id, options){
        return this.submitCommand({
            path: 'lock',
            id,
            params: options
        });
    },

    unLock: function(id, options){
        return this.submitCommand({
            path: 'unlock',
            id,
            params: options
        });
    }
};
